/**
 *  UserList.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component, useState } from "react";

// Tables
import {
  PagingState,
  IntegratedPaging,
  SearchState,
  IntegratedFiltering,
  SortingState,
  IntegratedSorting,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  Toolbar,
  TableHeaderRow,
  PagingPanel,
  SearchPanel,
} from "@devexpress/dx-react-grid-bootstrap3";

// notifications
import NotificationSystem from "react-notification-system";

// components
import UserModal from "./UserModal.jsx";
import Loading from "../Loader/Loader.jsx";

// style
import { style } from "../../variables/Variables.jsx";

class ImageWithFallback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // if incoming src is falsy use placeholder so <img> will render a valid src
      imgSrc: props.src || props.placeholder,
      // track the last prop src we synced so we can react to changes
      prevSrcProp: props.src,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // if the incoming src prop changed, update state so the component will
    // attempt to load the new image
    // react when src prop changes (including becoming falsy) and update imgSrc
    if (nextProps.src !== prevState.prevSrcProp) {
      return {
        imgSrc: nextProps.src || nextProps.placeholder,
        prevSrcProp: nextProps.src,
      };
    }
    return null;
  }

  handleError = () => {
    const { placeholder } = this.props;
    // only update to placeholder if it's different to avoid loops
    if (placeholder && this.state.imgSrc !== placeholder) {
      this.setState({ imgSrc: placeholder });
    }
  };

  render() {
    const { alt } = this.props;
    const { imgSrc } = this.state;

    return (
      <a
        href={imgSrc}
        onClick={(e) => {
          e.preventDefault();

          if (!imgSrc || imgSrc.includes("user.png")) return;
          window.open(imgSrc, "_blank");
        }}
        rel="noopener noreferrer"
      >
        <img
          src={imgSrc}
          alt={alt}
          onError={this.handleError}
          // use key so React will remount the element when src changes
          key={imgSrc}
          style={{
            width: 50,
            height: 50,
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      </a>
    );
  }
}

// global
var firebase = require("../../firebase");

class UserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        {
          name: "icon",
          title: "#",
          getCellValue: (row) => (
            <React.Fragment>
              <ImageWithFallback
                src={row.photoUrl}
                alt={"user image"}
                placeholder={
                  "https://firebasestorage.googleapis.com/v0/b/brasil-mais-seguro.firebasestorage.app/o/users%2Fphotos%2Fuser.png?alt=media"
                }
              />
            </React.Fragment>
          ),
        },
        { name: "name", title: "Nome" },
        { name: "phone", title: "Telefone" },
        { name: "city", title: "Cidade" },
        { name: "state", title: "Estado" },
        //{name: "activationCode", title: "Código"},
        {
          name: "status",
          title: "Alerta",
          getCellValue: (row) =>
            row.status === 1 ? (
              <span className="badge-danger">ATIVADO</span>
            ) : (
              <span className="badge-success">DESATIVADO</span>
            ),
        },
        {
          name: "actions",
          title: "Ações",
          getCellValue: (row) => this.actions(row),
        },
      ],
      showModal: false,
      rowSelected: null,
      _notificationSystem: null,
      indexSelected: null,
      lat: 0,
      lon: 0,
      url: "",
      loading: false,
      searchValue: "",
      sortColumns: [],
      tableColumnExtensions: [{ columnName: "icon", width: 60 }],
    };

    this.changeSearchValue = (value) => this.setState({ searchValue: value });
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  handleClose = () => {
    this.setState({ showModal: false, selection: [] });
  };

  handleShow = (row, index) => {
    this.setState({ loading: true }, () => {
      this.getLocation(row, index);
    });
  };

  actions = (row) => {
    const { users } = this.props;
    let index = users.indexOf(row);

    return (
      <div>
        <a
          onClick={() => {
            this.handleShow(row, index);
          }}
          className="link-edit"
        >
          <span className="text-warning" style={{ fontWeight: "bold" }}>
            <i className={`glyphicon glyphicon-globe`} /> RASTREAR
          </span>
        </a>
      </div>
    );
  };

  getLocation = (row, index) => {
    const userLocationRef = firebase.database.ref(
      `/locationUsers/${row.key}/l`
    );

    userLocationRef.once("value").then((snapshot) => {
      const userLocation = snapshot.val();

      if (userLocation != null) {
        const userLat = userLocation[0];
        const userLong = userLocation[1];
        this.setState({
          rowSelected: row,
          loading: false,
          showModal: true,
          lat: userLat,
          long: userLong,
          url:
            "https://www.google.com/maps/embed/v1/search?q=" +
            userLat +
            "%2C%20" +
            userLong +
            "&key=AIzaSyBQY9mebdLSt8IRHgre47-X9sW6unp5NnE",
        });
      } else {
        this.setState({ loading: false }, () => {
          this.notify("Nenhuma localização encontrada.", "error");
        });
      }
    });
  };

  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell" />,
      message: <div>{message}</div>,
      level: level,
      position: "tr",
      autoDismiss: 10,
    });
  };

  render() {
    const {
      columns,
      searchValue,
      sortColumns,
      tableColumnExtensions,
      showModal,
      url,
      loading,
      rowSelected,
    } = this.state;
    const { users } = this.props;

    return (
      <div>
        {showModal && (
          <UserModal
            show={showModal}
            handleHide={this.handleClose}
            url={url}
            rowSelected={rowSelected}
          />
        )}

        {loading && <Loading />}

        <NotificationSystem ref="notificationSystem" style={style} />

        <Grid rows={users} columns={columns}>
          <SearchState
            value={searchValue}
            onValueChange={this.changeSearchValue}
          />

          <PagingState defaultCurrentPage={0} defaultPageSize={20} />

          <SortingState defaultSorting={sortColumns} />

          <IntegratedFiltering />
          <IntegratedSorting />
          <IntegratedPaging />

          <Table columnExtensions={tableColumnExtensions} />
          <TableHeaderRow showSortingControls />
          <Toolbar />

          <SearchPanel />

          <PagingPanel pageSizes={[5, 15, 20, 25, 50, 100, 0]} />
        </Grid>
      </div>
    );
  }
}

export default UserList;



// WEBPACK FOOTER //
// ./src/views/Users/UserList.jsx